import { useState } from 'react';

import { Button, Flex, Text } from '@chakra-ui/react';
import Page from '@inspire/ui/chakra/layout/Page';

import { OnlyForSsoRegistered } from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import SignupLyceenProfileForm from 'components/signup/lyceen/SignupLyceenProfileForm';
import { CONNEXION_PATH } from 'lib/paths';
import LinkButton from 'components/general/LinkButton';
// import { useMyProfile } from 'lib/hooks';

const InscriptionLyceenPage = () => {
  // const { myProfile } = useMyProfile();
  const [emailAlreadyUsed, setEmailAlreadyUsed] = useState(false);

  return (
    <Page title={`Mon profil`} withPanel headingIsTitle>
      {emailAlreadyUsed ? (
        <>
          <Text mb={6} textAlign="center">
            Il existe déjà un compte avec cette adresse email. Si tu t'es déjà
            inscrit sur INSPIRE, connecte-toi avec ton compte existant.
          </Text>
          <Flex justifyContent="space-evenly" flexDir={['column', null, 'row']}>
            <LinkButton href={CONNEXION_PATH} my={2}>
              Je me connecte
            </LinkButton>
            <Button my={2} onClick={() => setEmailAlreadyUsed(false)}>
              Je m'inscris avec une autre adresse
            </Button>
          </Flex>
        </>
      ) : (
        <>
          <SignupLyceenProfileForm
            onEmailAlreadyUsed={() => setEmailAlreadyUsed(true)}
          />
        </>
      )}
    </Page>
  );
};

InscriptionLyceenPage.getWrappers = (page) => (
  <Layout rowVariant="yellow" containerWidth="sm">
    <OnlyForSsoRegistered>{page}</OnlyForSsoRegistered>
  </Layout>
);

export default InscriptionLyceenPage;
